const firebaseConfig = {

    apiKey: "AIzaSyDy53FRkFMPM3XCVFcqHSKsB5CLvXjaFQ8",
  
    authDomain: "dental-clinic-app-a682a.firebaseapp.com",
  
    projectId: "dental-clinic-app-a682a",
  
    storageBucket: "dental-clinic-app-a682a.appspot.com",
  
    messagingSenderId: "752487643363",
  
    appId: "1:752487643363:web:ae25c269471a92be4f6dd6"
  
  };
export default firebaseConfig;  